import { render, staticRenderFns } from "./FormulateObjectPersonal.vue?vue&type=template&id=5dfb66fa&"
import script from "./FormulateObjectPersonal.vue?vue&type=script&lang=ts&"
export * from "./FormulateObjectPersonal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports